const STORAGE_KEY = 'fams-system-changelog-last-seen';

export const readSystemChangelogLastSeen = () => {
  if (typeof window === 'undefined') return '';
  return window.localStorage.getItem(STORAGE_KEY) || '';
};

export const markSystemChangelogSeen = (publishedAt?: string | null) => {
  if (typeof window === 'undefined' || !publishedAt) return;
  const current = readSystemChangelogLastSeen();
  if (current >= publishedAt) return;
  window.localStorage.setItem(STORAGE_KEY, publishedAt);
  window.dispatchEvent(new Event('fams-system-changelog-seen'));
};

export const hasUnreadSystemChangelog = (publishedAt?: string | null) => {
  if (!publishedAt) return false;
  return publishedAt > readSystemChangelogLastSeen();
};
